// extracted by mini-css-extract-plugin
export default {"content":"OperationCard_content__4pB1k"};